// extracted by mini-css-extract-plugin
export default {"root":"AKW1LPJE","primary":"_1NDKtp6k","warning":"_3OUmTVyB","danger":"_2OyIKowr","success":"_2UZem5gx","flat":"_1xRtRqWy","inverse":"_1zQVDc1a"};